import React from "react";
import FinanceSliding from "../financeComponents/FinanceSliding";
import FinanceBanner from '../financeComponents/FinanceBanner';
import CompanyInsights from "../financeComponents/CompanyInsights";
import FinanceServices from "../financeComponents/FinanceServices";
import FinanceAboutUs from '../financeComponents/FinanceAboutUs';
import FinanceDashboard from "../financeComponents/FinanceDashboard";
import FinanceHowItWorks from "../financeComponents/FinanceHowItWorks";
import FinanceBlogs from "../financeComponents/FinanceBlogs";
import FinanceTeam from "../financeComponents/FinanceTeam";
import FinanceFeatures from "../financeComponents/FinanceFeatures";
import FinanceFooter from "../financeComponents/FinanceFooter";
import FinanceHelp from "../financeComponents/FinanceHelp";

const FinanceHome = () => {
  return (
    <>
      <FinanceBanner />
      <FinanceSliding />
      <FinanceAboutUs />
      <CompanyInsights />
      <FinanceServices />
      <FinanceHowItWorks />
      <FinanceDashboard />
      <FinanceFeatures />
      <FinanceTeam />
      <FinanceHelp />
      <FinanceBlogs />
      <FinanceFooter />
    </>
  );
};

export default FinanceHome;
